// Default custom class mapping based on notification type
const defaultCustomClassMap = {
    success: 'notification-unlock',
    warning: 'notification-lock',
    error: 'notification-lock',
    info: ''
}

export function showNotication(instance, type, message, options = {}) {
    // Automatically assign customClass based on type if not explicitly provided
    const customClass = options.customClass !== undefined 
        ? options.customClass 
        : defaultCustomClassMap[type] || ''
    
    instance.$message({
        showClose: true,
        message: message,
        type: type,
        duration: options.duration || 3000,
        offset: options.offset || 20,
        customClass: customClass,
        ...options
    })
}


